export default {
  'createBill.purchaseorderno': 'شماره سفارش خرید',
  // "createBill.phone": "تلفن",
  'createBill.IranBranchOffice,No.18,AlvandBuilding,AlvandSt.ArgentinaSq.,Tehran,Iran.Phone:+98 21 88663088': `
  ایران-تهران - میدان آرزانتین -خیابان الوند
  ساختمان الوند
  تلفن : +9821886677555`,
  // "createBill.argentina": "ایران-تهران-میدان آرژانتین",
  'createBill.date': 'تاریخ',
  'createBill.supplieraddress': 'آدرس تامیین کننده : ',
  'createBill.3061valiasrsttehraniran': 'تهران-ایران -میدان ولیعصر-#3061',
  'createBill.requestername': 'نام درخواست کننده :',
  'createBill.paymentterms': 'شرایط پرداخت',
  'createBill.frominvoicereceipt': 'از دریافت صورت حساب',
  'createBill.projectname': ' نام پروژه :',
  'createBill.test': 'تستی',
  'createBill.pos': 'POS',
  'createBill.description': 'توضیحات',
  'createBill.quantity': 'تعداد',
  'createBill.uom': 'UOM',
  'createBill.netprice': 'قیمت خالص',
  'createBill.per': 'Per',
  'createBill.totalprice': 'قیمت کل',
  'createBill.curr': 'واحد پول',
  'createBill.deliverydate': 'تاریخ تحویل',
  'createBill.NECfullHD1024': 'NEC - Full HD 1024',
  'createBill.sonyultraHD': 'SONY - Ultra HD',
  'createBill.xiaominormalheadset': 'Xiaomi - Normal Headset',
  'createBill.beatshighqualitywireless': 'Beats - High Quality - Wireless',
  'createBill.months': 'ماه',
  'createBill.hours': 'ساعت',
  'createBill.days': 'روز',
  'createBill.novartispharmaserviceAG': 'Novartis Pharma سرویس ',
  'createBill.totalgrossamount':
    'مجموع مبلغ کل (با در نظر گرفتن مالیات در صورت وجود)',
};
